declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        RELEASE: Record<string, any>;
    }
}

/**
 * Returns the API ENDPOINT
 * @returns {String} url
 */
export function getApiEndpoint(): string {
    let url = '';
    try {
        const API_URL = System.resolve('api_url');
        if (API_URL) {
            url = API_URL;
        }
    } catch (error) {
        const { RELEASE } = window;
        if (RELEASE && RELEASE.API_ENDPOINT) {
            url = RELEASE.API_ENDPOINT;
        }
    }
    return url;
}
